import { render, staticRenderFns } from "./travel.vue?vue&type=template&id=6b897ee2&scoped=true"
import script from "./travel.vue?vue&type=script&lang=js"
export * from "./travel.vue?vue&type=script&lang=js"
import style0 from "./travel.vue?vue&type=style&index=0&id=6b897ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b897ee2",
  null
  
)

export default component.exports